// ----------------------------------------------------------------------------
// Template: Ajaxify Cart Page
// ----------------------------------------------------------------------------

import { bindFormIncrementEvents } from 'snippets/_containers/form/form-increment';
import iamotaEventHandler from '../../assets/scripts/helpers/event-handler';

Shopify.AjaxifyCartPage = () => {
    const localeString = `/${window.Shopify.locale}-${window.Shopify.country.toLowerCase()}`;
    window.localeUrl = window.location.href.includes(localeString) ? localeString : '';

    const _config = {
        itemQuantitySelector    : '.cart__quantity',
        itemRemoveBtn           : '.cart__remove--ajax',
        shopifyAjaxCartURL      : window.localeUrl + '/cart.js',
        quantityInputDelayTime  : 500, // in milliseconds
        cartSubtotalSelector    : '.cart__subtotal-price',
        cartUndoMessageSelector : '.cart__undo-message',
        cartUndoButton          : '.cart__undo--ajax',
        checkoutButton          : '[name="checkout"]'
    };

    const _getInventory = () => {
        return fetch(window.localeUrl + '/cart?view=max-qty');
    };

    const _rerenderSection = (sectionHTML) => {
        const sectionContainer = document.querySelector('.main .shopify-section');
        const pageContainer = document.querySelector('.main');
        sectionContainer.remove();
        pageContainer.innerHTML = sectionHTML;
    };
    
    const _reinitialize = () => {
        Shopify.AjaxifyCartPage().init();
        Shopify.freeShippingProgress().init();
        bindFormIncrementEvents();
        window.van11yAccessibleModalTooltipAria(document.querySelector('.main .shopify-section'), false);
    };

    const _generateUndoMessage = (lineItemRemoveBtn) => {
        const cartUndoMessageSelector = document.querySelector(_config.cartUndoMessageSelector);
        const { lineItemId, lineItemTitle, lineItemQuantity } = lineItemRemoveBtn.dataset;

        const message = `
            <p>
                ${lineItemTitle} ${window.translations.cartProductRemovedMessage}
                <button type="button" class="cart__undo cart__undo--ajax" data-line-item-id="${lineItemId}" data-line-item-quantity="${lineItemQuantity}">
                    ${window.translations.cartUndoLabel}?
                </button>
            </p>
        `;

        if (cartUndoMessageSelector.innerHTML === '') {
            cartUndoMessageSelector.innerHTML = message;
        } else {
            cartUndoMessageSelector.classList.remove('js--fade-in');
            cartUndoMessageSelector.innerHTML = message;
            cartUndoMessageSelector.classList.add('js--fade-in');  
        }

        document.querySelector(_config.cartUndoButton)?.addEventListener('click', (e) => {
            const undoButton = e.currentTarget;
            _undoRemovedItem(undoButton);
        });
    };

    const _setLoading = (isLoading) => {
        if (isLoading) {
            document.querySelectorAll('.cart__item--total-wrapper .product__price').forEach(element => {
                element.classList.add('loading');
            });
            document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.add('loading')));
            document.querySelector('.cart__subtotal-price').classList.add('loading');
        } else {
            document.querySelectorAll('.cart__item--total-wrapper .product__price').forEach(element => {
                element.classList.remove('loading');
            });
            document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.remove('loading')));
            document.querySelector('.cart__subtotal-price').classList.remove('loading');
        }
    };

    const _showCartAlert = (itemQuantitySelector, message) => {
        const cartRow = itemQuantitySelector.closest('.cart__row');

        cartRow.querySelector('.cart__item--message').innerHTML = `
                <p>
                    ${message}
                </p>`;
    };

    const _removeLineItem = (lineItemRemoveBtn) => {
        const { lineItemId } = lineItemRemoveBtn.dataset;

        fetch(window.localeUrl + '/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({
                quantity: 0, 
                id: lineItemId,
                sections: 'main-content--cart'
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            return response.text();
        }).then((data) => {
            const dataParsed = JSON.parse(data);
            const { sections, ...cartState } = dataParsed;
            const sectionHTML = sections ? sections['main-content--cart'] : null;
        
            _rerenderSection(sectionHTML);
            _reinitialize();
            _generateUndoMessage(lineItemRemoveBtn);
        }).catch((error) => {
            console.error(error);
        });
    };

    const _updateLineItem = (itemQuantitySelector) => {
        let timeout;

        itemQuantitySelector.addEventListener('change', () => {
            if (itemQuantitySelector.value == 0) {
                const lineItem = itemQuantitySelector.closest('.cart__line-item');
                const lineItemRemoveBtn = lineItem.querySelector(_config.itemRemoveBtn);
                _removeLineItem(lineItemRemoveBtn);
                
            } else {
                if (itemQuantitySelector.value < 0) {
                    itemQuantitySelector.value = 1;
                }
                
                clearTimeout(timeout); 
                timeout = setTimeout(async () =>{
                    const inventoryRawData = await _getInventory();
                    const inventories = await inventoryRawData.json();

                    const { lineItemKey, lineItemId, index } = itemQuantitySelector.dataset;
                                 
                    
                    Object.entries(inventories).forEach(([key, value]) => { 
                        if (key === lineItemId) {
                            const availableQty = parseInt(value);
                            let selectedQuantity = itemQuantitySelector.value;
                            const currentValue = itemQuantitySelector.getAttribute('value');

                            _setLoading(true);

                            fetch(window.localeUrl + '/cart/change.js', {
                                method: 'POST',
                                body: JSON.stringify({ quantity: selectedQuantity, line: index, sections: 'main-content--cart' }),
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            }).then((response) => {
                                return response.text();
                            }).then((data) => {
                                const dataParsed = JSON.parse(data);
                                const { sections, ...cartState } = dataParsed;
                                const sectionHTML = sections ? sections['main-content--cart'] : null;

                                if (cartState.status === 422) {
                                    itemQuantitySelector.value = currentValue;
                                    _showCartAlert(itemQuantitySelector, cartState.message);
                                    _setLoading(false);
                                }
                            
                                if (sectionHTML) {
                                    _rerenderSection(sectionHTML);
                                    _reinitialize();
                                }
                            }).catch((error) => {
                                _setLoading(false);
                                console.error(error);
                            });
                        }
                    });
                }, _config.quantityInputDelayTime);
            }
        }); 
    };
    
    const _undoRemovedItem = (undoButton) => {
        const { lineItemId, lineItemQuantity } = undoButton.dataset;

        fetch(window.localeUrl+'/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ items: [ {quantity: lineItemQuantity, id: lineItemId} ], sections: 'main-content--cart' }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if(response.status!==200) {
                throw response;
            } else {
                return response.text();
            }
        }).then((data) => {
            const dataParsed = JSON.parse(data);
            const { sections, ...cartState } = dataParsed;
            const sectionHTML = sections ? sections['main-content--cart'] : null;

            _rerenderSection(sectionHTML);
            _reinitialize();
        }).catch(async (error) => {
            try {
                const errorObject = await error.json();
                if (errorObject?.description) {
                    const errorDescription = errorObject.description;
                    document.querySelector(_config.cartUndoMessageSelector).textContent(errorDescription);
                    return;
                }
            } catch {
                console.error(error);
            }
        });
    };

    const _init = function() {
        const removeButtons = document.querySelectorAll(_config.itemRemoveBtn);
        removeButtons.forEach((removeButton) => {
            removeButton?.addEventListener('click', function(e){
                e.preventDefault();
                _removeLineItem(e.currentTarget);
            });
        });
        
        const quantitySelectors = document.querySelectorAll(_config.itemQuantitySelector);
        quantitySelectors.forEach((itemQuantitySelector) => {
            _updateLineItem(itemQuantitySelector);
        });  
    };
    return {
        init: (params) => {
            params = params || {};
            Object.assign(_config, params);
            _init();
        },
        getConfig: () => {
            return _config;
        }
    };
};

document.addEventListener('DOMContentLoaded', () => {
    Shopify.AjaxifyCartPage().init();
});
